export default __webpack_public_path__ + "static/media/2503284.4df81718.jpg";